import { Directive, effect, inject, TemplateRef, ViewContainerRef } from '@angular/core';
import { AuthorizationService } from '../services/authorization/authorization.service';
import { AuthorizationStateService } from '../services/authorization/authorization-state.service';

@Directive({
  selector: '[isStaff]',
  standalone: true
})
export class IsStaffDirective {
  private readonly templateRef = inject(TemplateRef);
  private readonly viewContainer = inject(ViewContainerRef);
  private readonly authorizationService = inject(AuthorizationService);
  private readonly authorizationStateService = inject(AuthorizationStateService);

  private canViewElement = false;

  constructor() {
    effect(() => {
      const authorizationState = this.authorizationStateService.authorizationState();
      this.updateView(authorizationState);
    });
  }

  private updateView(authorizationState: any): void {
    const isStaff = authorizationState ? this.authorizationService.isStaff(authorizationState) : false;

    if (isStaff && !this.canViewElement) {
      this.showElement();
    } else if (!isStaff && this.canViewElement) {
      this.hideElement();
    }
  }

  private showElement(): void {
    if (!this.canViewElement) {
      this.viewContainer.createEmbeddedView(this.templateRef);
      this.canViewElement = true;
    }
  }

  private hideElement(): void {
    if (this.canViewElement) {
      this.viewContainer.clear();
      this.canViewElement = false;
    }
  }
}
